import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { walletApi } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
export var WalletService = /*#__PURE__*/function (_BaseResource) {
  _inherits(WalletService, _BaseResource);
  var _super = _createSuper(WalletService);
  function WalletService() {
    _classCallCheck(this, WalletService);
    return _super.apply(this, arguments);
  }
  _createClass(WalletService, [{
    key: "list",
    value:
    // 获取游戏投注详情
    function list() {
      return this.requester.post(walletApi.userList);
    }
  }, {
    key: "switch",
    value: function _switch(params) {
      return this.requester.post(walletApi.singleSwitch, params);
    }
    // 获取支持币种列表
  }, {
    key: "wallet_list",
    value: function wallet_list() {
      return this.requester.post(walletApi.pltList);
    }
  }]);
  return WalletService;
}(BaseResource);